import { FormattedMessage } from 'react-intl';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { TextAlignmentContainer } from '../../../../../TextAlignmentContainer/TextAlignmentContainer';
import { Text } from '../../../../../atoms/Text/Text';
import { commonMessages } from '../../../../../atoms/CommonMessages/messages';
import { H1 } from '../../../../../atoms/Heading/Heading';

type LoginTitleHeaderProps = {
  passwordHelpText: string;
};

export const LoginTitleHeader = ({ passwordHelpText }: LoginTitleHeaderProps) => {
  return (
    <Box mb="medium">
      <TextAlignmentContainer>
        <H1>
          <FormattedMessage {...commonMessages.logIn} />
        </H1>
        <Text color="secondary" mt="xxsmall">
          {passwordHelpText}
        </Text>
      </TextAlignmentContainer>
    </Box>
  );
};
